import React from "react";
import { useState, useEffect } from "react";
import {
  Form,
  Button,
  Col,
  Row,
  Modal,
  InputGroup,
  useAccordionButton,
  Accordion,
} from "react-bootstrap";
import {
  utilCreateDocument,
  utilGetCollectionFilterReference,
  getConsecutivoTurnero,
  getFolioVenta,
  utilGetCollectionFilter,
} from "../../../util/UtilsFirebase";
import "./IngresoManual.css";
import { useAuthContext } from "../../../hooks/useAuthContext";
import {
  collection,
  doc,
  getDoc,
  onSnapshot,
  updateDoc,
} from "firebase/firestore";
import { projectFirestore } from "../../../firebase/config";
import Ticket from "./Ticket";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import {
  faArrowDown,
  faArrowUp,
  faMinus,
  faPlus,
  faUser,
} from "@fortawesome/free-solid-svg-icons";
import PlatilloTurnero from "./PlatilloTurnero";
import Cobro from "./Cobro";
import VentanaMovible from "../../VentanaMovible";

const IngresoManual = ({ show, handleClose, orden, cajaID, userNew }) => {
  const { register, employee } = useAuthContext();
  const [option, setOption] = useState("categorias");
  const [ordenaGenerar, setOrdenaGenerar] = useState(
    orden
      ? orden
      : {
          fecha: null,
          number: null,
          user_name: "",
          user: null,
          status: "CAPTURA",
          tipo_pago: "Efectivo",
          total: 0,
          puesto: register.id,
          puesto_name: register.name,
          puesto_img: register.img,
          detalle: [],
        },
  );
  const [data, setData] = useState([]);
  const [dataPla, setDataPla] = useState([]);
  const [dataAnadidos, setDataAnadidos] = useState([]);
  const [dataIngrentes, setDataIngredientes] = useState([]);
  const [nombre, setNombre] = useState(
    orden?.user_name ? orden?.user_name : "",
  );
  const [impresion, setImpresion] = useState(false);
  const [orderDetail, setOrderDetail] = useState(
    orden?.detalle ? orden.detalle : [],
  );
  const [modIngreso, setModIngreso] = useState(false);
  const [menuid, setMenuId] = useState("");
  const [categoria, setCategoria] = useState("todo");
  const [iva, setIva] = useState("0");
  const [fecha, setfecha] = useState("");
  const [folio, setfolio] = useState(orden?.folio ? orden?.folio : "");
  const [mostrarord, setMostrarord] = useState(true);
  const [empleado, setEmpleado] = useState("");
  const [tBusqueda, setTBusqueda] = useState("");

  const handleClosePedido = () => {
    if (modIngreso) {
      handleCloseLocal();
      setOrdenaGenerar({
        fecha: null,
        number: null,
        user_name: "",
        user: null,
        status: "CAPTURA",
        tipo_pago: "Efectivo",
        total: 0,
        puesto: register.id,
        puesto_name: register.name,
        puesto_img: register.img,
        detalle: [],
      });
      setModIngreso(false);
      setMostrarord(true);
    }
  };

  const total = orderDetail.reduce((acc, item) => {
    return (
      acc +
      parseFloat(item.cantidad) *
        (parseFloat(item.costo) + parseFloat(item.totalAnadidos))
    );
  }, 0);

  const totaliva = total - total / (1 + iva / 100);

  const puntosgenerados = orderDetail.reduce((acc, item) => {
    return acc + parseFloat(item.cantidad) * parseFloat(item.puntos);
  }, 0);

  // const totalplatillos = orderDetail.reduce((acc, item) => {
  //   return acc + parseFloat(item.cantidad) * parseFloat(item.costo);
  // }, 0);

  // const totalanadidos = orderDetail.reduce((acc, item) => {
  //   return acc + parseFloat(item.cantidad) * parseFloat(item.totalAnadidos);
  // }, 0);

  const platfiltered = dataPla.filter((item) => {
    if (categoria !== "todo") {
      return item.categoria.id === categoria;
    } else return true;
  });

  function CustomToggle({ text, eventKey }) {
    const decoratedOnClick = useAccordionButton(eventKey, () => {
      setMostrarord(!mostrarord);
    });

    return (
      <h5 style={{ color: "#0229AAF3" }} onClick={decoratedOnClick}>
        ORDEN ACTUAL{" "}
        {mostrarord ? (
          <FontAwesomeIcon icon={faArrowUp} />
        ) : (
          <FontAwesomeIcon icon={faArrowDown} />
        )}
      </h5>
    );
  }

  const handleCloseLocal = async () => {
    if (orden) {
      handleClose(ordenaGenerar);
    } else {
      handleClose();
    }
    setNombre("");
    setModIngreso(false);
    setOrdenaGenerar({
      fecha: null,
      number: null,
      user_name: "",
      user: null,
      status: "CAPTURA",
      tipo_pago: "Efectivo",
      total: 0,
      puesto: register.id,
      puesto_name: register.name,
      puesto_img: register.img,
      detalle: [],
    });
    setOrderDetail([]);
  };

  const handleRemovePlatillo = (itemtoRemove) => {
    const newOrderDetail = orderDetail.filter((item) => item !== itemtoRemove);
    setOrderDetail(newOrderDetail);
    setOrdenaGenerar({
      ...ordenaGenerar,
      detalle: newOrderDetail,
    });
  };

  const anadirALista = (platilloDetalle) => {
    const updatedOrderDetail = [...orderDetail, platilloDetalle];
    setOrderDetail(updatedOrderDetail);
    setOrdenaGenerar({
      ...ordenaGenerar,
      detalle: updatedOrderDetail,
    });
    document.getElementById("efec")?.focus();
  };

  const sumCantidad = (item) => {
    const newOrderDetail = orderDetail.map((ite) => {
      if (ite === item) {
        let itecopi = ite;
        itecopi.cantidad = parseInt(itecopi.cantidad) + 1;
        return itecopi;
      } else return ite;
    });
    setOrderDetail(newOrderDetail);
    setOrdenaGenerar({
      ...ordenaGenerar,
      detalle: newOrderDetail,
    });
  };

  const resCantidad = (item) => {
    if (parseInt(item.cantidad) > 1) {
      const newOrderDetail = orderDetail.map((ite) => {
        if (ite === item) {
          let itecopi = ite;
          itecopi.cantidad = parseInt(itecopi.cantidad) - 1;
          return itecopi;
        } else return ite;
      });
      setOrderDetail(newOrderDetail);
      setOrdenaGenerar({
        ...ordenaGenerar,
        detalle: newOrderDetail,
      });
    }
  };

  const handleNota = (item, nota) => {
    const newOrderDetail = orderDetail.map((ite) => {
      if (ite === item) {
        let itecopi = ite;
        itecopi.note = nota;
        return itecopi;
      } else return ite;
    });
    setOrderDetail(newOrderDetail);
    setOrdenaGenerar({
      ...ordenaGenerar,
      detalle: newOrderDetail,
    });
  };

  const mandarOrden = async (
    impres,
    reclamados,
    metodopago,
    cambio,
    cobro,
    puntosusados,
  ) => {
    if (orderDetail.length <= 0) {
      alert("Seleccione al menos un platillo.");
      return;
    }
    const confirmVal = window.confirm(
      !orden
        ? "¿Estás seguro de que deseas generar el turno?"
        : "¿Estás seguro de que deseas actualizar la informacion?",
    );
    if (confirmVal && !orden) {
      const numero = await getConsecutivoTurnero(register.id);
      const updatedOrderGenerar = {
        ...ordenaGenerar,
        fecha: new Date(),
        folio: folio,
        number: numero,
        total: total,
        status: "ATENDIDO",
        tipo_pago: "Mixto",
        tipo_venta: "Mostrador",
        caja: cajaID,
        equivalenciapuntos: register.equivalenciapuntos
          ? parseFloat(register.equivalenciapuntos)
          : 0,
        ordenadoPor: "Web Rapdis",
        puntosusados: puntosusados,
        puntosgenerados: puntosgenerados,
        iva: iva,
        reclamados: reclamados,
        cobroiva: totaliva,
        cambio: cambio,
        cobro: cobro,
        user_name: nombre,
        metodosPago: metodopago,
      };
      if (nombre === "") {
        updatedOrderGenerar.user_name = "Publico en general";
      }
      if (
        metodopago.efectivo > 0 &&
        metodopago.tarjeta <= 0 &&
        metodopago.vale <= 0 &&
        metodopago.transferencia <= 0
      ) {
        updatedOrderGenerar.tipo_pago = "Efectivo";
      } else if (
        metodopago.efectivo <= 0 &&
        metodopago.tarjeta > 0 &&
        metodopago.vale <= 0 &&
        metodopago.transferencia <= 0
      ) {
        updatedOrderGenerar.tipo_pago = "Tarjeta";
      } else if (
        metodopago.efectivo <= 0 &&
        metodopago.tarjeta <= 0 &&
        metodopago.vale > 0 &&
        metodopago.transferencia <= 0
      ) {
        updatedOrderGenerar.tipo_pago = "Vales";
      } else if (
        metodopago.efectivo <= 0 &&
        metodopago.tarjeta <= 0 &&
        metodopago.vale <= 0 &&
        metodopago.transferencia > 0
      ) {
        updatedOrderGenerar.tipo_pago = "Transferencia";
      } else {
        updatedOrderGenerar.tipo_pago = "Mixto";
      }
      if (employee !== undefined) {
        updatedOrderGenerar.atendio = employee.id_usuario;
      } else {
        updatedOrderGenerar.atendio = "Administrador";
      }
      setOrdenaGenerar(updatedOrderGenerar);
      await utilCreateDocument("turnero", updatedOrderGenerar);
      updatedOrderGenerar.detalle.forEach(async (itemdet) => {
        if (itemdet?.id && itemdet?.selectedDate) {
          const documplat = doc(
            projectFirestore,
            "menu",
            menuid,
            "platillo",
            itemdet.id,
          );
          if (itemdet?.selectedDate && itemdet?.selectedTime) {
            const dataplat = (await getDoc(documplat)).data();
            let dispo3 = { ...dataplat?.reservados };
            if (
              dispo3 &&
              dispo3[itemdet?.selectedDate] &&
              dispo3[itemdet?.selectedDate][itemdet?.selectedTime]
            ) {
              dispo3[itemdet?.selectedDate][itemdet?.selectedTime] =
                dispo3[itemdet?.selectedDate][itemdet?.selectedTime] -
                itemdet?.cantidad;
            }
            let dispo2 = { ...dataplat?.fechas };
            if (
              dispo2 &&
              dispo2[itemdet?.selectedDate] &&
              dispo2[itemdet?.selectedDate][itemdet?.selectedTime]
            ) {
              dispo2[itemdet?.selectedDate][itemdet?.selectedTime] =
                dispo2[itemdet?.selectedDate][itemdet?.selectedTime] +
                itemdet?.cantidad;
            } else if (
              dispo2 &&
              dispo2[itemdet?.selectedDate] &&
              !dispo2[itemdet?.selectedDate][itemdet?.selectedTime]
            ) {
              dispo2 = {
                ...dispo2,
                [itemdet?.selectedDate]: {
                  ...dispo2[itemdet?.selectedDate],
                  [itemdet?.selectedTime]: itemdet?.cantidad,
                },
              };
            } else if (dispo2 && !dispo2[itemdet?.selectedDate]) {
              dispo2 = {
                ...dispo2,
                [itemdet?.selectedDate]: {
                  [itemdet?.selectedTime]: itemdet?.cantidad,
                },
              };
            } else {
              dispo2 = {
                [itemdet?.selectedDate]: {
                  [itemdet?.selectedTime]: itemdet?.cantidad,
                },
              };
            }
            updateDoc(documplat, {
              fechas: dispo2,
              reservados: dispo3,
            });
          } else {
            const dataplat = (await getDoc(documplat)).data();
            let dispo3 = { ...dataplat?.reservados };
            if (
              dispo3 &&
              dispo3[itemdet?.selectedDate] &&
              dispo3[itemdet?.selectedDate][itemdet?.selectedDate]
            ) {
              dispo3[itemdet?.selectedDate][itemdet?.selectedDate] =
                dispo3[itemdet?.selectedDate][itemdet?.selectedDate] -
                itemdet?.cantidad;
            }
            let dispo2 = { ...dataplat?.fechas };
            if (
              dispo2 &&
              dispo2[itemdet?.selectedDate] &&
              dispo2[itemdet?.selectedDate][itemdet?.selectedDate]
            ) {
              dispo2[itemdet?.selectedDate][itemdet?.selectedDate] =
                dispo2[itemdet?.selectedDate][itemdet?.selectedDate] +
                itemdet?.cantidad;
            } else if (
              dispo2 &&
              dispo2[itemdet?.selectedDate] &&
              !dispo2[itemdet?.selectedDate][itemdet?.selectedDate]
            ) {
              dispo2 = {
                ...dispo2,
                [itemdet?.selectedDate]: {
                  ...dispo2[itemdet?.selectedDate],
                  [itemdet?.selectedDate]: itemdet?.cantidad,
                },
              };
            } else if (dispo2 && !dispo2[itemdet?.selectedDate]) {
              dispo2 = {
                ...dispo2,
                [itemdet?.selectedDate]: {
                  [itemdet?.selectedDate]: itemdet?.cantidad,
                },
              };
            } else {
              dispo2 = {
                [itemdet?.selectedDate]: {
                  [itemdet?.selectedDate]: itemdet?.cantidad,
                },
              };
            }
            updateDoc(documplat, {
              fechas: dispo2,
              reservados: dispo3,
            });
          }
        }
      });
      if (impres === true) {
        setImpresion(true);
      } else {
        setImpresion(false);
        handleCloseLocal();
      }
      return [updatedOrderGenerar];
    }
  };

  useEffect(() => {
    async function getMenu() {
      const menuH = await utilGetCollectionFilterReference(
        "menu",
        "registro",
        "==",
        register.id,
        "registro",
      );
      let q = doc(projectFirestore, "menu", menuH[0].id);
      const docSnapshot = await getDoc(q);
      if (docSnapshot.exists()) {
        setMenuId(docSnapshot.id);
        let documentosColeccionCat = [];
        onSnapshot(collection(q, "categoria"), (docs) => {
          documentosColeccionCat = [];
          docs.docs.forEach((doc) => {
            const data = doc.data();
            data.id = doc.id;
            documentosColeccionCat.push(data);
          });
          setData(documentosColeccionCat);
        });
        onSnapshot(collection(q, "platillo"), (docs) => {
          const documentosColeccion = [];
          docs.docs.forEach(async (doc) => {
            const data = doc.data();
            data.id = doc.id;
            data.refDoc = doc.ref;
            data.categoria = documentosColeccionCat.filter((s) => {
              return s.id === data.categoria.id;
            })[0];
            documentosColeccion.push(data);
          });
          setDataPla(documentosColeccion);
        });
        onSnapshot(collection(q, "anadidos"), (docs) => {
          const documentosColeccion = [];
          docs.docs.forEach(async (doc) => {
            const data = doc.data();
            data.id = doc.id;
            documentosColeccion.push(data);
          });
          setDataAnadidos(documentosColeccion);
        });
        onSnapshot(collection(q, "ingredientes"), (docs) => {
          const documentosColeccion = [];
          docs.docs.forEach(async (doc) => {
            const data = doc.data();
            data.id = doc.id;
            documentosColeccion.push(data);
          });
          setDataIngredientes(documentosColeccion);
        });
      }
    }
    getMenu();
  }, [register.id]);

  useEffect(() => {
    if (employee !== undefined) {
      const personal = utilGetCollectionFilter(
        "users",
        "id",
        "==",
        employee.id_usuario,
      );
      personal.then((result) => {
        setEmpleado(result[0]);
      });
    }
    const folioV = async () => {
      let ds = await getFolioVenta(register.id);
      setfolio(ds.count);
    };
    if (show && !modIngreso) {
      setImpresion(false);
      if (!orden) {
        setModIngreso(true);
        folioV();
      } else {
        setModIngreso(true);
        setOrdenaGenerar(orden);
        setOrderDetail(orden.detalle);
        setNombre(orden.user_name);
        setfolio(orden.folio);
      }
      setInterval(() => {
        setfecha(
          new Date()
            .toLocaleString("es-ES", {
              hour: "numeric",
              minute: "numeric",
              hour12: true,
              day: "2-digit",
              month: "2-digit",
              year: "numeric",
            })
            .toUpperCase(),
        );
      }, 1000);
    }
    if (register.frontera) {
      setIva(16);
    } else {
      setIva(8);
    }
  }, [
    employee,
    modIngreso,
    ordenaGenerar,
    register.frontera,
    register.id,
    show,
    iva,
    orden,
  ]);

  useEffect(() => {
    if (userNew) {
      getDoc(doc(projectFirestore, "users", userNew)).then((dat) => {
        const datDoc = dat.data();
        setNombre(datDoc.fullName);
      });
    }
  }, [userNew]);

  return (
    <div>
      <Modal
        show={modIngreso}
        onHide={handleClosePedido}
        onExit={handleClosePedido}
        onEntering={() => {
          document.getElementById("nombre")?.focus();
        }}
        fullscreen
      >
        <Row style={{ marginTop: "10px" }}>
          <Col md={3}>
            <Button
              onClick={(e) => {
                e.preventDefault();
                handleClosePedido();
              }}
              variant="ds"
              id="volverturnero"
              style={{ color: "black", fontSize: 22 }}
              className="newbutton-style nonfilledtext-color"
            >
              {"< "}
              INGRESO MANUAL
            </Button>
          </Col>
          <Col
            md={4}
            style={{
              borderWidth: 1,
              borderStyle: "solid",
              borderRadius: 10,
              borderColor: "#74727296",
              padding: 8,
              paddingLeft: 15,
            }}
          >
            <Row>
              <Col md={10}>
                <h6
                  style={{
                    color: "#333232",
                    fontWeight: "600",
                  }}
                >
                  Nombre del cliente
                </h6>
                <Form.Control
                  id="nombre"
                  placeholder="Publico en general"
                  style={{
                    border: "0px",
                    padding: "0px",
                    boxShadow: "unset",
                    borderRadius: 0,
                  }}
                  value={nombre}
                  onChange={(e) => setNombre(e.target.value)}
                />
              </Col>
              <Col md={2} style={{ alignContent: "center" }}>
                <FontAwesomeIcon icon={faUser} color="gray" size="2x" />
              </Col>
            </Row>
          </Col>
          <Col
            md={5}
            style={{
              alignContent: "center",
              display: "flex",
              flexDirection: "row",
            }}
          >
            <Button
              variant="ds"
              id={option === "categorias" ? "options-active" : "options"}
              className="newbutton-style nonfilledtext-color"
              onClick={() => {
                setOption("categorias");
              }}
            >
              <i
                className="bx bx-category"
                style={{ fontSize: "25px", marginRight: 10 }}
              ></i>
              Por categorías
            </Button>
            <Button
              variant="ds"
              id={option === "todo" ? "options-active" : "options"}
              className="newbutton-style nonfilledtext-color"
              onClick={() => {
                setOption("todo");
              }}
            >
              <i
                className="bx bx-list-ul"
                style={{ fontSize: "25px", marginRight: 10 }}
              ></i>
              Todo el menú
            </Button>
            <Button
              variant="ds"
              id={option === "vendidos" ? "options-active" : "options"}
              className="newbutton-style nonfilledtext-color"
              onClick={() => {
                setOption("vendidos");
              }}
            >
              <i
                className="bx bx-star"
                style={{ fontSize: "25px", marginRight: 10 }}
              ></i>
              Mas vendidos
            </Button>
          </Col>
        </Row>
        <Modal.Body
          style={{ display: "flex", flexDirection: "row", flexWrap: "wrap" }}
        >
          <Col
            sm={12}
            xl={8}
            style={{
              borderWidth: 1,
              borderStyle: "solid",
              borderRadius: 10,
              height: "100%",
              borderColor: "#74727259",
            }}
          >
            <Row
              id="rowbsnone"
              style={{
                overflow: "auto",
                flexWrap: "unset",
                overflowY: "hidden",
              }}
            >
              <Button
                variant="ds"
                id={categoria === "todo" ? "options-active" : "options"}
                className="newbutton-style nonfilledtext-color"
                onClick={() => {
                  setCategoria("todo");
                }}
              >
                <i
                  className="bx bx-list-ul"
                  style={{ fontSize: "25px", marginRight: 10 }}
                ></i>
                Todo
              </Button>
              {data
                .filter((val) => {
                  return val?.active;
                })
                .map((item, index) => {
                  return (
                    <Button
                      variant="ds"
                      id={categoria === item.id ? "options-active" : "options"}
                      className="newbutton-style nonfilledtext-color"
                      onClick={() => {
                        setCategoria(item.id);
                      }}
                    >
                      {item.name}
                    </Button>
                  );
                })}
            </Row>
            <Row id="rowbsnone">
              <InputGroup className="mb-2" style={{ justifyContent: "center" }}>
                <InputGroup.Text style={{ fontSize: 13 }}>
                  <i className="bx bx-search" />{" "}
                </InputGroup.Text>
                <Form.Control
                  id="busquedaturnero"
                  placeholder="Buscar platillo por nombre o codigo"
                  value={tBusqueda}
                  onChange={(e) => {
                    setTBusqueda(e.target.value);
                  }}
                />
              </InputGroup>
            </Row>
            <Row
              id="rowbsnone"
              style={{
                flexWrap: "wrap",
                textAlign: "center",
                height: "80%",
                overflowY: "auto",
              }}
            >
              {platfiltered
                .filter((item) => {
                  if (tBusqueda !== "") {
                    return item.name
                      .toLowerCase()
                      .includes(tBusqueda.toLowerCase());
                  } else {
                    return true;
                  }
                })
                .map((item, index) => {
                  return (
                    <PlatilloTurnero
                      platillo={item}
                      agregar={anadirALista}
                      anadidos={dataAnadidos}
                      ingredientes={dataIngrentes}
                      detalleorden={orderDetail}
                      sumCantidad={sumCantidad}
                      resCantidad={resCantidad}
                      remove={handleRemovePlatillo}
                      item={orderDetail}
                      handleNote={handleNota}
                    />
                  );
                })}
            </Row>
          </Col>
          <Col
            sm={12}
            xl={4}
            style={{
              borderWidth: 1,
              borderStyle: "solid",
              borderRadius: 10,
              height: "100%",
              overflow: "auto",
              flexWrap: "unset",
              overflowX: "hidden",
              borderColor: "#74727259",
              backgroundColor: "white",
              zIndex: 50,
            }}
          >
            <Accordion defaultActiveKey={"Orden"}>
              <Row style={{ padding: 7 }}>
                <Col md={6} style={{ alignContent: "center" }}>
                  <CustomToggle eventKey={"Orden"} />
                </Col>
                <Col
                  md={6}
                  style={{ alignContent: "center", textAlign: "end" }}
                >
                  <Button
                    onClick={() => {
                      setOrderDetail([]);
                    }}
                    variant="light"
                    style={{
                      color: "red",
                      fontWeight: "bold",
                      alignContent: "center",
                    }}
                    // id="cancelar"
                    // className="newbutton-style nonfilledtext-color"
                  >
                    <i
                      className="bx bx-trash icon"
                      style={{ fontSize: "22px" }}
                    ></i>
                    Vaciar orden
                  </Button>
                </Col>
              </Row>
              <Accordion.Collapse eventKey="Orden">
                <Row
                  style={{
                    marginLeft: 5,
                    marginRight: 20,
                    alignContent: "center",
                  }}
                >
                  {orderDetail.map((item) => {
                    return (
                      <>
                        <Col
                          md={1}
                          style={{
                            alignContent: "center",
                          }}
                        >
                          <img
                            src={item.img}
                            alt=""
                            width={"30rem"}
                            height={"40rem"}
                            style={{ objectFit: "contain" }}
                          />
                        </Col>
                        <Col
                          md={4}
                          style={{
                            alignContent: "center",
                          }}
                        >
                          {item.name}
                          <br /> ({item.ncosto})
                        </Col>
                        <Col
                          md={4}
                          style={{
                            alignContent: "center",
                          }}
                        >
                          <InputGroup
                            className="mb-2"
                            style={{ justifyContent: "center" }}
                          >
                            <Button
                              variant="light"
                              onClick={() => {
                                resCantidad(item);
                              }}
                            >
                              <FontAwesomeIcon
                                icon={faMinus}
                                style={{ fontSize: 13 }}
                              />
                            </Button>
                            <InputGroup.Text style={{ fontSize: 13 }}>
                              {item.cantidad}
                            </InputGroup.Text>
                            <Button
                              variant="light"
                              onClick={() => sumCantidad(item)}
                            >
                              <FontAwesomeIcon
                                icon={faPlus}
                                style={{ fontSize: 13 }}
                              />
                            </Button>
                          </InputGroup>
                        </Col>
                        <Col
                          md={2}
                          style={{
                            alignContent: "center",
                          }}
                        >
                          $
                          {(
                            parseFloat(item.cantidad) *
                            (parseFloat(item.costo) +
                              parseFloat(item.totalAnadidos))
                          ).toFixed(2)}
                        </Col>
                        <Col
                          md={1}
                          style={{
                            alignContent: "center",
                          }}
                        >
                          <VentanaMovible
                            platillo={dataPla.find((plat) => {
                              return plat.id === item.id;
                            })}
                            agregarNota={true}
                            chico={true}
                            // selectCostosItem={selectCostosItem}
                            platinorder={item}
                            handleNote={handleNota}
                          />
                          <Button
                            variant="outline-dark"
                            onClick={() => handleRemovePlatillo(item)}
                          >
                            <i
                              className="bx bx-trash icon"
                              style={{ fontSize: 17, color: "red" }}
                            ></i>
                          </Button>
                        </Col>
                      </>
                    );
                  })}
                </Row>
              </Accordion.Collapse>
              <Row
                style={{
                  justifyContent: "space-between",
                  marginTop: 10,
                  paddingLeft: 15,
                  paddingRight: 15,
                }}
              >
                <Col md={6}>
                  <h5>Puntos generados:</h5>
                </Col>
                <Col md={6} style={{ textAlign: "right" }}>
                  <h5 className=" fw-bold">{puntosgenerados}</h5>
                </Col>
              </Row>
              <Row
                style={{
                  justifyContent: "space-between",
                  paddingLeft: 15,
                  paddingRight: 15,
                }}
              >
                <Col md={6}>
                  <h5>Total a pagar:</h5>
                </Col>
                <Col md={6} style={{ textAlign: "right" }}>
                  <h5 className="text-danger fw-bold">${total.toFixed(2)}</h5>
                </Col>
              </Row>
            </Accordion>

            <Cobro
              total={total}
              // user={"BD7QodJ4aOUT0H2GdGay6fX8H0b2"}
              user={userNew}
              register={register}
              mandarOrden={mandarOrden}
              puntosgenerados={puntosgenerados}
              folio={folio}
            />
          </Col>
        </Modal.Body>
        <Row style={{ paddingLeft: 15, paddingRight: 15, paddingBottom: 5 }}>
          <Col md={3}>
            <i className="bx bx-user" style={{ fontSize: 22 }} />
            <strong>Atendido por: </strong>
            {employee !== undefined ? empleado.fullName : "Administrador"}
          </Col>
          <Col md={3}>
            <strong>Tipo de venta:</strong> Mostrador
          </Col>
          <Col md={3}>
            <strong>Folio de venta:</strong> {folio}
          </Col>
          <Col md={3}>
            <strong>Fecha y hora:</strong> {fecha}
          </Col>
        </Row>
      </Modal>
      <Ticket
        orden={ordenaGenerar}
        registro={register}
        impresion={impresion}
        handleClose={handleCloseLocal}
        setImpresion={setImpresion}
      />
    </div>
  );
};

export default IngresoManual;
